export default {"src":"/_next/static/media/eye_closed.b8385e79.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};